"use strict";

PF.Options = class Options
	{
	static populate(entity, options)
		{
		let defaultOptions = PF.Options.createDefault(entity);

		let result = PF.Options.mergeObjects(defaultOptions, options);

		if (result.dom !== undefined)
			{
			if (result.dom.constructor.name !== 'Dom')
				{
				result.dom = new PF.Dom(result.dom);
				}
			}

		if (result.populateOptions === true)
			{
			for (let key in result)
				{
				entity[key] = result[key];
				}
			}
		entity.options = result;
		}

	static createDefault(entity)
		{
		let target = Object.getPrototypeOf(entity);
		let parentsOptions = [];
		while (!target.constructor.name.startsWith('Entity')/* !== 'Entity' && target.constructor.name !== 'Entity' && target.constructor.name !== 'EntityArray' && target.constructor.name !== 'EntityObject'*/)
			{
			parentsOptions.push(target.constructor.options);
			target = Object.getPrototypeOf(target);
			}

		parentsOptions.push(target.constructor.options);

		let pattern = {};
		for (let i = parentsOptions.length; i >= 0; i--)
			{
			pattern = PF.Options.mergeObjects(pattern, parentsOptions[i]);
			}

		return pattern;
		}

	static mergeObjects(targetObject, object)
		{
		if (object === undefined)
			{
			return targetObject;
			}

		if (typeof object !== 'object' || object === null)
			{
			return object;
			}

		if (!(object.constructor.name === 'Object' || object.constructor.name === 'Array'))
			{
			return object;
			}

		let result = null;
		if (object instanceof Array)
			{
			result = [];
			if (!(targetObject instanceof Array))
				{
				targetObject = [];
				}
			for (let i = 0; i < Math.max(targetObject.length, object.length); i++)
				{
				if (targetObject[i] !== undefined && object[i] !== undefined)
					{
					result.push(PF.Options.mergeObjects(targetObject[i], object[i]));
					}
				else if (targetObject[i] === undefined && object[i] !== undefined)
					{
					result.push(PF.Options.mergeObjects({}, object[i]));
					}
				else if (targetObject[i] !== undefined && object[i] === undefined)
					{
					result.push(PF.Options.mergeObjects(targetObject[i], {}));
					}
				}
			}
		else if (object instanceof Object)
			{
			result = {};
			result = Object.assign(result, targetObject);
			for (let key in object)
				{
				if ((key.startsWith('$') && typeof object[key] === 'object'))
					{
					result[key] = object[key];
					}
				else
					{
					let target = result[key];
					result[key] = PF.Options.mergeObjects(target, object[key]);
					}
				}
			}

		return result;
		}

	static assignOptions(target, options)
		{
		for (let key in options)
			{
			let value = options[key];

			if (value.constructor.name !== 'Object')
				{
				target[key] = value;
				}
			else
				{
				if (target[key] === undefined || target[key] === null)
					{
					target[key] = {};
					}
				PF.Options.assignOptions(target[key], value);
				}
			}
		}
	};